import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import AbilitiesService from 'donor-elf-web/services/abilities';
import Papa from 'papaparse';

export default class ContactsUploadController extends Controller {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare uploadContacts: any;

  @tracked mightBeProspectToolFile: boolean = false;
  @tracked errorMessage?: string;

  @action
  templateDidInsert() {
    this.mightBeProspectToolFile = false;
    this.errorMessage = undefined;
  }

  @action
  onFileInputChange(e: any) {
    this.mightBeProspectToolFile = false;
    this.errorMessage = undefined;
    if (e.target.files.length === 0) {
      return;
    }

    let file = e.target.files[0] as File;
    if (
      file.type === 'text/csv' ||
       // Firefox honors the Windows MIME type under HKEY_CLASSES_ROOT\.csv\Content Type
      (file.name.endsWith('.csv') && file.type === 'application/vnd.ms-excel')
    ) {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.processFileString(e.target.result);
      };
      reader.readAsText(file);
    } else if (
      file.name.match(/prospect/i) &&
      this.abilities.hasAbility('import_iv_prospects')
    ) {
      this.mightBeProspectToolFile = true;
    } else {
      this.errorMessage = 'Please select a file in the .csv format';
    }
  }

  processFileString(fileString: string) {
    let csv = Papa.parse(fileString, { header: true });
    let columns = csv.meta.fields;
    set(this.uploadContacts, 'columns', columns);
    set(this.uploadContacts, 'fileData', csv.data);
    this.router.transitionTo('funds.fund.contacts.upload.map');
  }
}
